@if (anlaeg) {
  <div class="unit">
    @if (anlaeg) {
      <mat-tab-group mat-align-tabs="start" [color]="'accent'">
        <mat-tab label="Anlæg">
          <div class="card">
            <div class="detail-rows detail-rows--transparent hidden-btn-edit">
              <div class="detail-row">
                <div class="detail-row__lbl bold">Fabrikat</div>
                <div class="detail-row__val">{{ anlaeg.fabrikat ? anlaeg.fabrikat.name : anlaeg.alternativFabrikat }}</div>
              </div>
              <div class="detail-row">
                <div class="detail-row__lbl bold">Model</div>
                <div class="detail-row__val">{{ anlaeg.model ? anlaeg.model.name : anlaeg.alternativModel }}</div>
              </div>
              <div class="detail-row">
                <div class="detail-row__lbl bold">Installatør</div>
                <div class="detail-row__val">{{ anlaeg.installatoer ? anlaeg.installatoer.name : anlaeg.alternativInstallatoer }}</div>
              </div>
              <div class="detail-row">
                <div class="detail-row__lbl bold">Installationsdato</div>
                <div class="detail-row__val">{{ anlaeg.installationDate | date : 'dd.MM.yyyy' }}</div>
              </div>
              <div class="detail-row">
                <div class="detail-row__lbl bold">Serienummer</div>
                @if (anlaeg.serienummer) {
                  <div class="detail-row__val">
                    {{ anlaeg.serienummer }}
                  </div>
                }
              </div>
              <div class="detail-row">
                <div class="detail-row__lbl bold">Garanti</div>
                @if (anlaeg.garantiPeriode && anlaeg.installationDate) {
                  <div class="detail-row__val">
                    {{ anlaeg.garantiPeriode }} måneder ({{ anlaegGarantiEndDate | date : 'dd.MM.yyyy' }})
                  </div>
                }
              </div>
              <div class="detail-row">
                <div class="detail-row__lbl bold">Effekt</div>
                <div class="detail-row__val">
                  @if (anlaeg.minEffekt && anlaeg.minEffekt != anlaeg.maxEffekt) {
                    <span>{{ anlaeg.minEffekt }}-{{ anlaeg.maxEffekt }} kW</span>
                  }
                  @if (anlaeg.minEffekt == anlaeg.maxEffekt || !anlaeg.minEffekt) {
                    <span>{{ anlaeg.maxEffekt }} kW</span>
                  }
                </div>
              </div>
              <div class="detail-row">
                <div class="detail-row__lbl bold">Adresse</div>
                <div class="detail-row__val">{{ serviceAftaleAdresse }}</div>
              </div>
              @if (!isVarmepumpe) {
                <div class="detail-row">
                  <div class="detail-row__lbl bold">Storbrænder</div>
                  <div class="detail-row__val">{{ anlaeg.storbraender ? 'Ja' : 'Nej' }}</div>
                </div>
                @if (isOlie) {
                  <div class="detail-row">
                    <div class="detail-row__lbl bold">Kondenserende</div>
                    <div class="detail-row__val">{{ anlaeg.kondenserende ? 'Ja' : 'Nej' }}</div>
                  </div>
                }
                <div class="detail-row">
                  <div class="detail-row__lbl bold">Driftform</div>
                  <div class="detail-row__val">{{ anlaeg.driftform?.text }}</div>
                </div>
              }
              <div class="detail-rows__edit">
                <button type="button" class="btn-icon btn-blue-edit" [disabled]="!canWrite" (click)="editAnlaeg()" matTooltip="Rediger anlæg">
                  <mat-icon svgIcon="edit"></mat-icon>
                </button>
              </div>
            </div>
          </div>
        </mat-tab>
        @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
          <mat-tab label="Tilvalg">
            <app-tilvalg [serviceaftale]="serviceaftale" [tilvalg]="tilvalg" [hasRights]="hasRightsToChangeTilvalg"></app-tilvalg>
          </mat-tab>
        }
      </mat-tab-group>
    }
    <app-komponent-list
      [komponenter]="anlaeg.komponenter"
      (addKomponent)="addKomponent()"
      (editKomponent)="editKomponent($event)"
      (deleteKomponent)="deleteKomponent($event)"
    ></app-komponent-list>
  </div>
}
